import React, { PropsWithChildren } from 'react';

type HelpLayoutProps = PropsWithChildren<{
  sidebar: React.ReactNode;
  header: React.ReactNode;
}>;

export default function HelpLayout({ sidebar, header, children }: HelpLayoutProps) {
  return (
    <div className="min-h-screen bg-[#0f1116] text-slate-100">
      <header className="sticky top-0 z-1 border-b border-slate-800 bg-[#151823]">{header}</header>

      <div className="mx-auto grid max-w-6xl grid-cols-1 lg:[grid-template-columns:280px_1fr]">
        <aside className="sticky top-[110px] hidden h-[calc(100vh-110px)] overflow-auto border-r border-slate-800 bg-[#151823] p-4 lg:block">
          {sidebar}
        </aside>

        <main className="min-h-[calc(100vh-68px)] bg-[#1b2030] p-6" id="main-content">
          {children}
        </main>
      </div>
    </div>
  );
}
